import { UpdateUserDto } from "lib/features/user/types";
import api from "./api";

export interface CheckEmailInUseDto {
  email: string;
}

export interface CreateUserDto {
  email: string;
  auth_type?: number;
  password?: string;
  first_name: string;
  last_name: string;
  avatar: string | undefined;
  role_id: number;
  stripe_id?: string;
  about_me: string;
  external_token?: string;
  accepted_terms_and_conditions?: boolean;
  region_id: number;
  work_place?: string;
  job_type?: string;
  influencer_type_id: number;
  customer_type_ids: number[];
  categories_ids: number[];
}

export interface ForgotPaswordDto {
  email: string;
}

export interface VerifyOtpDto {
  email: string;
  otp: string;
}

export interface ResetPasswordDto {
  email: string;
  otp: string;
  newPassword: string;
  confirmPassword: string;
}

export interface UserCustomerType {
  id: number;
  type: string;
}

const authServices = {
  login(payload: object) {
    return api.post("/user/login", JSON.stringify(payload), {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  assume(id: number) {
    return api.get("/user/assume/"+id.toString(), {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  delete(id: number) {
    return api.delete("/user/"+id.toString(), {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  googleLogin(payload: object) {
    return api.post("/user/google/login", JSON.stringify(payload), {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  signUp(payload: object) {
    return api.post("/user", payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },

  createUser(user: CreateUserDto) {
    return api.post("/user", JSON.stringify(user), {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },

  forgotPassword(body: ForgotPaswordDto) {
    return api.post("/user/forgot-password", JSON.stringify(body), {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },

  verifyOtp(body: VerifyOtpDto) {
    return api.post("/user/verify-otp", JSON.stringify(body), {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },

  resetPassword(body: ResetPasswordDto) {
    return api.post("/user/reset-password", JSON.stringify(body), {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },

  checkEmail(email: CheckEmailInUseDto) {
    return api.post("/user/check-email", JSON.stringify(email), {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },

  fetchUser(user_id: number) {
    return api.get(`/user/${user_id}`);
  },

  fetchUserStatistics(user_id: number) {
    return api.get(`/user/statistics/user/${user_id}`);
  },

  updateUser(user: UpdateUserDto, user_id: number) {
    return api.put(`/user?id=${user_id}`, JSON.stringify(user), {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },

  getCustomerType() {
    return api.get("/user/customer-types");
  },
};

export default authServices;
